import { PriceClass } from '../../services/amsSearch/amsSearch.interface'
import { PriceText } from './AmsRatingLights/AmsRatingLights.interface'

export const determinePriceTextBy = (priceClass: PriceClass) => {
    switch (priceClass) {
        case PriceClass.HighPrice:
            return PriceText.HighPrice
        case PriceClass.IncreasedPrice:
            return PriceText.IncreasedPrice
        case PriceClass.FairPrice:
            return PriceText.FairPrice
        case PriceClass.GoodPrice:
            return PriceText.GoodPrice
        case PriceClass.VeryGoodPrice:
            return PriceText.VeryGoodPrice
        default:
            return PriceText.NotSpecified
    }
}
